import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import LandingSectionHeader from "./LandingSectionHeader";
import "./LandingProductsSection.css";

const PRODUCTS = [
  {
    icon: <MenuBookOutlinedIcon />,
    name: "База знаний",
    accent: "kb",
    title: "Ответ на рабочий вопрос за секунду",
    desc: "Сотрудник не ищет инструкцию в чатах и не ждёт наставника — открывает бота и сразу находит нужную подсказку. HR один раз задаёт стандарт, команда пользуется каждый день.",
  },
  {
    icon: <AccountTreeOutlinedIcon />,
    name: "Сценарий",
    accent: "scenario",
    title: "Обучение, где решения имеют значение",
    desc: "Сотрудник проходит рабочую ситуацию шаг за шагом и видит, к чему приводит каждый выбор. Так быстрее запоминаются правила, чем при просмотре длинной записи.",
  },
  {
    icon: <QuizOutlinedIcon />,
    name: "Тренажёр",
    accent: "trainer",
    title: "Проверка знаний и рост команды",
    desc: "После обучения команда отвечает на вопросы в боте и сразу видит результат. HR понимает, кто усвоил материал, а рейтинг и ачивки мотивируют заниматься дальше.",
  },
];

export default function LandingProductsSection() {
  return (
    <section
      id="platform"
      className="landing-band landing-band--platform landing-section landing-section--products"
    >
      <div className="landing-container">
        <LandingSectionHeader
          label="01 · Возможности"
          title="Что умеет платформа"
          desc="Мы предоставляем три инструмента — база знаний, сценарий и тренажёр — для обучения, подсказок и развития команды. Настроить их может HR, технические знания не нужны."
        />

        <div className="landing-band__panel landing-band__panel--platform">
          <div className="landing-products-grid">
            {PRODUCTS.map(({ icon, name, accent, title, desc }) => (
              <article
                className={`landing-product-card landing-product-card--${accent}`}
                key={name}
              >
                <h3 className="landing-product-card__name">{name}</h3>
                <div className="landing-product-card__icon">{icon}</div>
                <h4 className="landing-product-card__title">{title}</h4>
                <p className="landing-product-card__desc">{desc}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
